import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import { useMemo } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";

import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import SyncIcon from "@mui/icons-material/Sync";

import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const mapProfileStatusTitle = (status) => {
  switch (status) {
    case 0:
      return "تکمیل نشده";
    case 1:
      return "تکمیل شده";
    case 2:
      return "تایید شده";
    default:
      return "نامشخص";
  }
};

const isValidDate = (value) =>
  value &&
  value !== "0001-01-01T00:00:00" &&
  !String(value).startsWith("0001-01-01");

const mapProfileRows = (list) =>
  (Array.isArray(list) ? list : []).map((row) => ({
    ...row,
    createOn:
      [row.createOn, row.createdOn, row.updateOn].find(isValidDate) || null,
    updateOn:
      [row.updateOn, row.createOn, row.createdOn].find(isValidDate) || null,
    profileConfirmationStatusTitle: mapProfileStatusTitle(
      row.profileConfirmationStatus
    ),
  }));

const ProfileApprovalPage = () => {
  const pageInfo = useGetPageInfo();
  const dataList = useLoaderData();
  let navigate = useNavigate();

  const rows = useMemo(() => mapProfileRows(dataList), [dataList]);

  const headCells = [
    {
      id: "createOn",
      label: "تاریخ ایجاد",
      type: "date",
    },
    {
      id: "userName",
      label: "نام کاربری",
    },
    {
      id: "firstName",
      label: "نام",
    },
    {
      id: "lastName",
      label: "نام خانوادگی",
    },
    {
      id: "nationalCode",
      label: "کد ملی",
    },
    {
      id: "mobile",
      label: "شماره همراه",
    },
    {
      id: "email",
      label: "ایمیل",
    },
    {
      id: "profileConfirmationStatusTitle",
      label: "وضعیت",
    },
  ];

  const onViewProfile = (row) => {
    navigate(`${row.userId}`);
  };

  const onFetchData = () => {
    navigate();
  };

  const getRowStatus = (row) => {
    switch (row.profileConfirmationStatus) {
      case 0:
        return "gray";
      case 1:
        return "warning";
      case 2:
        return "success";
      default:
        return "gray";
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title || "تایید پروفایل‌ها"}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"userId"}
                  rows={rows}
                  headCells={headCells}
                  defaultSort={{ orderBy: "createOn", order: "desc" }}
                  pageSize={100}
                  actions={[
                    {
                      icon: useCheckPermission("edit") ? (
                        <ContentPasteSearchIcon
                          sx={{ width: "1rem", height: "1rem" }}
                        />
                      ) : null,
                      onClick: onViewProfile,
                      color: "primary",
                      tooltip: "بررسی",
                    },
                  ]}
                  getRowStatus={getRowStatus}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ProfileApprovalPage;
